export default __webpack_public_path__ + "static/media/menu.3937f54d.svg";